import { routes } from "src/shared/routes";
import {
  FAQS,
  TERMS_AND_CONDITION,
  CHECKOUT_TERMS_AND_CONDITION,
  REGISTRATION_CARDS,
} from "./helper";
import { constants } from "src/shared/constants";

import logoImage from "public/images/knicks_gardendeck/knicks-mock-logo.png";
import backgroudImage from "public/images/knicks_gardendeck/knicks_garden_deck_background.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const TEAM_SCHEMA = "knicks_gardendeck";
const desktopBanner =
  "https://ss-leagues.s3.amazonaws.com/NBA/New%20York%20Knicks/NYK2627_AccountManager_Tiles_GardenDeck_DesktopBanner-1920x450.jpg";
const mobileBanner =
  "https://ss-leagues.s3.amazonaws.com/NBA/New%20York%20Knicks/NYK2627_AccountManager_Tiles_GardenDeck_MobileBanner-375x550.jpg";

export const knicks_gardendeck: TTeamConfig = {
  TEAM_SCHEMA,
  CLIENT_ID: "14722a2f1643.seasonshare.msg-msg.us",
  TEAM_FULL_NAME: "Knicks Garden Deck",
  BROWSER_TITLE: "Knicks Garden Deck",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/msg/my-events",
    COLORS_PRIMARY: "#F58426",
    COLORS_SECONDARY: "#00438C",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_CROWD_HANDLER_ENABLED: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
    REGISTRATION_CARD_SETTINGS: {
      HIDE_SECTION_TITLE: true,
      REGISTRATION_CARDS: REGISTRATION_CARDS,
    },
  },

  HOME_PAGE_SETTINGS: {
    DEFAULT_PAGE_TOP_NOTIFICATION: {
      DESCRIPTION:
        "You can hold and manage up to four (4) different game reservations at a time. Once a reserved game passes, you can come back to reserve another game.",
      BACKGROUND_COLOR: "#00438C",
    },
    ATTEND_EVENT_MODAL: {
      TITLE: "Manage Reservation",
      DESCRIPTION: (
        <>
          By reserving a game you are committing to attend. If you are unable to
          attend, you must cancel at least 48 hours in advance. <br />
          <br />
          *The Knicks reserve the right to reduce the number of game
          reservations you may hold at one time if you do not cancel a
          reservation at least 48 hours in advance.
        </>
      ),
      CHANGE_SEAT_COUNT_BUTTON_LABEL: "Change Seat Count",
      ATTEND_BUTTON_LABEL: "Reserve",
      NOT_ATTENDING_BUTTON_LABEL: "Cancel Reservation",
      ATTEND_BUTTON_ATTENDING_LABEL: "Reserved",
      ATTEND_BUTTON_NOT_ATTENDING_LABEL: "Not Reserved",

      ATTENDANCE_SUCCESS_TOAST: {
        OPT_IN_SUCCESS_MESSAGE:
          "Your reservation has been updated successfully.",
        OPT_OUT_SUCCESS_MESSAGE:
          "Your reservation has been cancelled successfully.",
      },
    },

    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_LABEL: "Reserve",

      IS_RESERVATION_ENABLED: true,

      RESERVATION_LIMIT_REACHED_MESSAGE:
        "You’ve reached the maximum active game reservations. Once one of your reserved games has passed, you’ll be able to make a new reservation.",

      RESERVATION_ADD_ON_SEATS_CLAIMED_MESSAGE:
        "This reservation cannot be canceled because additional guest tickets have been purchased for the event.",

      RESERVATION_OPT_OUT_DISABLED_MESSAGE: (
        <>
          The window to cancel your reservation has closed. Please call{" "}
          <a href="tel:212-465-6073">212-465-6073</a> for additional help.
        </>
      ),

      SEAT_COUNT_LIMIT_REACHED_MESSAGE:
        "All seats for this event have been reserved. Please check back in case additional seats become available.",
    },

    ADD_ON: {
      OPT_IN_REQUIRED_MESSAGE:
        "Please complete your pass reservation before purchasing additional guest seats.",
    },

    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  PURCHASE_HISTORY_PAGE_SETTINGS: {
    IS_RESEVATION_HISTORY_ENABLED: true,

    PURCHASE_HISTORY_ZERO_STATE: {
      TITLE: "No orders yet",
      DESCRIPTION: "Only purchases made on this platform will appear here.",
    },
  },

  IMAGES: {
    LOGO_URL: logoImage.src,

    LANDING_PAGE_STATIC_BANNER_URL: desktopBanner,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBanner,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBanner,
    ORDER_SUMMERY_BACKGROUND_URL: backgroudImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION: CHECKOUT_TERMS_AND_CONDITION,
  },
};
